export const BlankList = ({ permissions, ...props }) => {
    return (<span>You are Not Authorized to access this website. This voilation will be logged and reported</span>)
}